module.exports = __webpack_public_path__ + "assets/87d5d35ed257d7c71495072c2352647a.png";